import React from 'react';
import PropTypes from 'prop-types';
import PracticeSkillBox from 'chameleon-packages/units/components/PracticeSkillBox';
import './SkillPopOverContent.scss';

const SkillPopOverContent = React.forwardRef((props, ref) => {
  const { skill, id } = props;
  const { label, category, name } = skill;
  const cleanInfo = (info) => info && info?.split(':')?.[1];
  const cleanCategory = cleanInfo(category);
  const cleanName = cleanInfo(name);
  const cleanedLabel = label || (name && name?.split(':')?.[0]);

  return (
    <div
      role="region"
      className="SkillPopOverContent"
      ref={ref}
      id={id}
      aria-live="assertive"
    >
      <div className="sr-only">
        {cleanedLabel}
        {cleanCategory}
        {cleanName}
      </div>
      <div aria-hidden>
        <PracticeSkillBox label={cleanedLabel} tabIndex={-1} />
      </div>
      <div aria-hidden className="header" data-id={`${id}-header`}>
        {cleanCategory}
      </div>
      <div
        aria-hidden
        className="font-normal leading-normal"
        data-id={`${id}-body`}
      >
        {cleanName}
      </div>
    </div>
  );
});

SkillPopOverContent.propTypes = {
  skill: PropTypes.object,
};

export default SkillPopOverContent;
